import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import useVueCompositionApi from '@/js/common/plugins/use-vue-composition-api';
import HotelOffersSearchController from '@/js/desktop/components/hotelOffersSearch/HotelOfferSearchController';
import SocialButtons from '@/js/desktop/components/social-btns';
import defaultTourCriteriaAdapter from '@/js/common/services/atlas-hotel/defaultTourCriteriaAdapter';
import initGallery from '../common/initGallery';

import '../atlas/css/atlas-header-withMenu.scss';
import '../atlas/css/atlas-page-sections.css';
import '@/css/desktop/search';
import '@/css/desktop/search/destination-info-atlas.css';
import './style/atlas-hotel.scss';

$(() => {
    useVueCompositionApi();
    window.appConfig.defaultTourCriteria = defaultTourCriteriaAdapter(window.appConfig.defaultTourCriteria);

    const searchController = new HotelOffersSearchController({
        el: 'body',
    });

    new SocialButtons({
        el: '.social-btns',
    });

    searchController.initSearchOnScroll(() => {
        initGallery();
    });
});